import { Button, DialogActions, DialogContent, Typography } from '@mui/material';
import React from 'react';
import { BhiDialog } from 'src/UIKit';
import { ContactCaptureConfirmation } from './useContactCaptureListActions';

type Props = {
  confirm: ContactCaptureConfirmation | null;
  onCloseConfirmation: () => void;
};

export const ContactCaptureListDialogs = ({ confirm, onCloseConfirmation }: Props) => (
  <BhiDialog open={Boolean(confirm)} onClose={onCloseConfirmation} title={confirm?.title} maxWidth="xs" fullWidth>
    <DialogContent><Typography variant="body2">{confirm?.content}</Typography></DialogContent>
    <DialogActions>
      <Button variant="outlined" onClick={onCloseConfirmation}>Cancel</Button>
      <Button
        variant="contained"
        onClick={() => {
          const action = confirm?.action;
          onCloseConfirmation();
          if (action) void action();
        }}
      >
        {confirm?.confirmLabel}
      </Button>
    </DialogActions>
  </BhiDialog>
);
